import React, {useEffect, useState} from 'react';
import {isPRD} from '../../../utlis/vars';
import Text from '../@Text/Text/Text';
import './style.scss';

const enum GovernmentIDInputType {
  SSN = "SSN",
  EIN = "EIN"
}

interface IGovernemntIDInput {
  type: GovernmentIDInputType;
  'data-testid'?: string;
  onChange?: (value: string) => void;
}

const times = (num: number, type: GovernmentIDInputType, fn: (i: number, num: number, arr: number[]) => React.ReactElement, hyphenFunction: (i: number) => React.ReactElement) => {
  let i = num;
  const arr = new Array(num - 1);

  while (i--) {
    arr[i] = fn(i, num, arr);
  }

  if (type === GovernmentIDInputType.SSN) {
    arr.splice(3, 0, hyphenFunction(0))
    arr.splice(6, 0, hyphenFunction(1))
  }

  if (type === GovernmentIDInputType.EIN) {
    arr.splice(2, 0, hyphenFunction(0))
  }

  return arr;
};

class GovernmentIDInputField extends React.Component<any, any> {
  constructor(props: unknown) {
    super(props);
    // @ts-ignore
    this.input = null;
  }

  focus() {
    // @ts-ignore
    this.input.setSelectionRange(0, this.input.value.length);
    // @ts-ignore
    this.input.focus();
  }

  render() {
    return (
      <input
        className="fm-government-id-input-field"
        maxLength={1}
        type="text"
        inputMode="numeric"
        onChange={this.props.onChange}
        onKeyUp={this.props.onKeyUp}
        onFocus={this.props.onFocus}
        ref={input => {
          // @ts-ignore
          this.input = input;
        }}
        {...this.props}
      />
    );
  }
}

const GovernmentIDInput = ({
                             'data-testid': dataTestId,
                             type,
                             onChange
                           }: IGovernemntIDInput): React.ReactElement => {
  const name = 'fms';

  const [values, setValues] = useState<{ [key: string]: string }>({});
  const numberOfCharacters = 9
  const label = type === GovernmentIDInputType.SSN ? "Social Security Number" : "Employer Identification Number"

  useEffect(() => {
    if (!onChange) return;
    onChange(Object.values(values).join(''));
  }, [values, onChange]);

  let targets: HTMLInputElement[] = [];

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "ArrowLeft") {
      targets[Math.max(index - 1, 0)].focus();
      return;
    }
    if (e.key === "ArrowRight") {
      targets[Math.min(index + 1, numberOfCharacters)].focus();
      return;
    }
    if (e.key === "Backspace") {
      targets[Math.max(index - 1, 0)].focus();
      setValues({...values, [index]: ""});
      return;
    }

    // @ts-ignore
    // on change won't fire if it's the same value, progress forward if the key press is the same value as the current value
    if (e.key === `${e.target.value}`) {
      targets[Math.min(index + 1, numberOfCharacters)].focus();
      return;
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let value = e.target.value;

    // React Input does not honor maxLength on number
    // However, you cannot restrict text to only be numbers
    // We set the input mode to numeric, and restrict non-numbers in the input here.
    if (isNaN(parseInt(value))) {
      // @ts-ignore
      e.target.value = ""
      return;
    }

    if (index >= numberOfCharacters) {
      return;
    }

    targets[Math.min(index + 1, numberOfCharacters)].focus();

    setValues({...values, [index]: value});
  };

  return (
    <div
      className="fm-government-id"
      data-testid={isPRD ? undefined : dataTestId}
      data-value={isPRD ? undefined : Object.values(values).join('')}
    >
      <Text className="fm-government-id-label" size="xs" color="blue" lineHeight="sm">
        {label}
      </Text>

      <div className="fm-government-id-inputs">
        {times(numberOfCharacters + 1, type, (index: number) => (
          <GovernmentIDInputField
            id={`fms-${name}${index}`}
            key={index}
            name={`fms-${index}`}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, index)}
            onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => handleKeyUp(event, index)}
            ref={(target: any) => {
              targets[index] = target;
            }}
          />
        ), (index: number) => (
          <span key={"hyphen-" + index}>-</span>
        ))}
      </div>
    </div>
  );
};

export {GovernmentIDInput, GovernmentIDInputType};
